module.exports = __webpack_public_path__ + "img/physicsbuilding-v-474x632.8d27a898.jpg";